<template>

    <Toast/>

    <div class="px-6 surface-overlay relative">

        <div v-show="activeTab === 1" class="grid">
            <div class="col-12 md:col-12">
                <div class="card p-fluid">

                    <div style="height: 10px;"></div>

                    <div v-if="this.headingReference === 'Y' && ( (digitalForm.logo != null) || (company.logo != null))" class="field">
                        <img :src="imageSrc" alt="Logo" class="form-logo" />
                    </div>

                    <div v-if="this.headingReference === 'Y'" class="field">
                        <p>&nbsp;</p>
                    </div>

                    <h3>{{ this.digitalForm.name }}</h3>

                    <div v-if="this.headingReference === 'Y'" class="field">
                        <p v-html="this.digitalForm.openingTerms"/>
                    </div>

                    <div v-if="this.headingReference === 'Y'" class="field">
                        <p>&nbsp;</p>
                    </div>


                    <div v-for="component in visibleComponents" :key="component.id" class="field">
                        <label v-if="( (component.type === 'S') || (component.type === 'N') || (component.type === 'B') ||
                                       (component.type === 'D') || (component.type === 'G') || (component.type === 'L') ||
                                       (component.type === 'M') )"
                                    :for="component.name">{{ component.name }}</label><br>

                        <InputText
                            v-if="component.type === 'S'"
                            :id="component.name"
                            v-model.trim="component.response"
                            :placeholder="component.name"
                            :class="{'p-invalid': (component.required === 'Y') && !component.response}"
                            required/>

                        <InputNumber
                            v-else-if="component.type === 'N'"
                            :id="component.name"
                            v-model="component.response"
                            :placeholder="component.name"
                            :class="{'p-invalid': (component.required === 'Y') && !component.response}"
                            required/>

                        <Dropdown
                            v-else-if="component.type === 'B'"
                            :id="component.name"
                            v-model="component.response"
                            :options="optionTypes" optionLabel="name" optionValue="code"
                            :placeholder="component.name"/>

                        <Dropdown
                            v-else-if="component.type === 'M'"
                            :id="component.name"
                            v-model="component.response"
                            :options="parseOptions(component.extendedValue)"
                            optionLabel="name"
                            optionValue="name"
                            :placeholder="component.name"/>

                        <Calendar
                            v-else-if="component.type === 'D'"
                            :id="component.name"
                            v-model="component.response"
                            :placeholder="component.name"
                            :showTime="false"
                            :showSeconds="false"
                            :showIcon="true"
                            dateFormat="yy-mm-dd"
                            :class="{'p-invalid': (component.required === 'Y') && !component.response}"
                            required/>

                        <div v-else-if="component.type === 'G'" class="field">
                            <vueSignature
                                ref="signature"
                                :sigOption="option"
                                :w="'400px'"
                                :h="'200px'"
                                :disabled="disabled"
                            ></vueSignature>
                            <button @click="save">Save</button>
                            <button @click="clear">Clear</button>
                            <button @click="undo">Undo</button>
                        </div>

                        <div v-else-if="component.type === 'H'" class="field">
                            <h3>{{ component.name }}</h3>
                        </div>

                        <div v-else-if="component.type === 'L'" class="field">
                            <p>&nbsp;</p>
                        </div>

                        <div v-else-if="component.type === 'T' && component.extendedValue !== null" class="field">
                            <p v-html="component.extendedValue"/>
                        </div>

                        <p v-else>Unsupported component type: {{ component.type }}</p>

                        <small v-if="(component.required === 'Y') && (component.type != 'B') && !component.response" class="p-error">
                            {{ component.name }} is required.
                        </small>

                    </div>

                    <div class="field">
                        <p>&nbsp;</p>
                    </div>

                    <div class="field">
                        <p>&nbsp;</p>
                    </div>

                    <div v-if="this.headingReference === 'Y'" class="field">
                        <p v-html="this.digitalForm.closingTerms"/>
                    </div>

                    <div v-if="this.headingReference === 'Y'" class="field">
                        <p>&nbsp;</p>
                    </div>

                    <Button label="Create" class="mr-2 mb-2" :loading="submitted" :disabled="!allFieldsFilled"
                            @click="createEntry"></Button>
                    <Button label="Cancel" class="mr-2 mb-2" :loading="submitted" @click="callReset"></Button>

                </div>
            </div>
        </div>


        <div v-show="activeTab === 2" class="grid">
            <div class="col-12 md:col-12">
                <div class="card p-fluid">

                    <h3>Invalid Form</h3>

                    <div class="field">
                        <p>
                            The details provided for the form are incorrect. Please retry with the correct information.
                        </p>
                    </div>

                </div>
            </div>
        </div>

    </div>

    <IsoEvolveFooter/>

</template>

<script>
import IsoEvolveFooter from "@/components/heading/authentication/IsoEvolveFooter.vue";
import UserService from "@/service/UserService";
import DigitalFormService from "@/service/DigitalFormService";
import DigitalForm from "@/service/DigitalFormService";
import vueSignature from "vue-signature";
import moment from "moment/moment";
import CompanyService from "@/service/CompanyService";

export default {
    components: {
        IsoEvolveFooter, vueSignature
    },
    async mounted() {
        try {
            const userPingResponse = await UserService.getUserPing();
            console.log("[PmOverviewDashboard][mounted] System is active.");
            console.log("[PmOverviewDashboard][mounted] Data = ", userPingResponse);
        } catch (e) {
            console.log("[PmOverviewDashboard][mounted] System is NOT active.");
            console.log("[PmOverviewDashboard][mounted] Error = ", e);
            this.$router.push("login");
            return;
        }

        this.companyReference = this.$route.query.company;
        this.formReference = this.$route.query.form;
        this.headingReference = this.$route.query.heading;

        if (this.headingReference == null) {
            this.headingReference = 'Y';
        }

        console.log("[DigitalForm][mounted] companyReference = ", this.companyReference);
        console.log("[DigitalForm][mounted] formReference = ", this.formReference);
        console.log("[DigitalForm][mounted] headingReference = ", this.headingReference);

        const promises = [
            DigitalFormService.getDigitalForm(this.companyReference, this.formReference)
        ];

        const [digitalFormResult] =
            await Promise.allSettled(promises);

        const [companyData] = await Promise.all([
            CompanyService.getCompany(this.companyReference)
        ]);

        this.company = companyData.data;

        if (digitalFormResult.status === "fulfilled") {
            this.digitalForm = digitalFormResult.value.data;
            this.activeTab = 1;

            this.digitalForm.formComponent.forEach(component => {
                component.response = ''; // Add the 'response' property directly
                // component.mandatory = true;
            });

        } else {
            console.log("[DigitalForm][mounted] Error = ", digitalFormResult.reason);
            this.activeTab = 2;
        }

        this.processImageSrc();
    },
    data() {

        return {
            profile: {},
            company: {},
            submitted: false,
            companyReference: null,
            formReference: null,
            headingReference: 'Y',
            digitalForm: {},
            // userResponses: {},
            responses: [],
            optionTypes: [
                {name: 'True', code: 'True'},
                {name: 'False', code: 'False'}
            ],
            listTypes: [
                {name: 'Option1', code: 'One'},
                {name: 'Option2', code: 'Two'},
                {name: 'Option3', code: 'Three'},
                {name: 'Option4', code: 'Four'},
                {name: 'Option5', code: 'Five'}
            ],
            form: {
                name: "",
                openingTerms: "",
                closingTerms: "",
                formcomponent: [] // Initial array to store components
            },
            loading: true,
            activeTab: 1,
            option: {
                penColor: "rgb(0, 0, 0)",
                backgroundColor: "rgb(255,255,255)",
            },
            disabled: false,
            signature: null,
            imageSrc: '', // Default value for image source
            errorMessage: '', // Error message for handling invalid cases
        }
    },
    computed: {
        allFieldsFilled() {
            const items =
                this.digitalForm && this.digitalForm.formComponent != null
                    ? this.digitalForm.formComponent
                    : [];

            return items.every(c => {
                const isActive = c.status === 'A';
                const isRequired = c.required === 'Y' && c.type !== 'B';
                return !isActive || !isRequired || !!c.response;
            });
        },
        visibleComponents() {
            const items = (this.digitalForm && this.digitalForm.formComponent) || [];
            return items.filter(c => c && c.status !== 'I');
        },
    },
    methods: {
        callReset() {
            this.activeTab = 1;
        },
        resetForm() {
            this.digitalForm.formComponent.forEach(component => {
                component.response = ''; // Reset all responses including the signature
            });

            if (this.$refs.signature) {
                this.$refs.signature.clear(); // Clear the signature pad
            }

            this.submitted = false;

        },
        processImageSrc() {
            if (this.company.logo != null) {
                const match = this.company.logo.match(/<img\s+[^>]*src="([^"]+)"/);
                if (match && match[1]) {
                    this.imageSrc = match[1]; // Valid base64 data URL
                    this.errorMessage = ''; // Clear any previous error messages
                } else {
                    this.imageSrc = ''; // Default or empty value
                    this.errorMessage = 'Invalid image data'; // Set an appropriate error message
                }
            } else if (this.digitalForm.logo != null) {
                const match = this.digitalForm.logo.match(/<img\s+[^>]*src="([^"]+)"/);
                if (match && match[1]) {
                    this.imageSrc = match[1]; // Valid base64 data URL
                    this.errorMessage = ''; // Clear any previous error messages
                } else {
                    this.imageSrc = ''; // Default or empty value
                    this.errorMessage = 'Invalid image data'; // Set an appropriate error message
                }
            }
        },
        save() {
            const signatureData = this.$refs.signature.save();
            const signatureComponent = this.digitalForm.formComponent.find(component => component.type === 'G');
            if (signatureComponent) {
                signatureComponent.response = signatureData;
            }
        },
        clear() {
            this.$refs.signature.clear();
            const signatureComponent = this.digitalForm.formComponent.find(component => component.type === 'G');
            if (signatureComponent) {
                signatureComponent.response = ''; // Clear the response as well
            }
            console.log("Signature cleared");
        },
        undo() {
            this.$refs.signature.undo();
            console.log("Undo last signature stroke");
        },
        parseOptions(response) {
            console.log("[parseOptions] response = ", response);
            if (!response) return [];  // Return empty array if response is empty or null

            var result = response.split(',').map((item) => ({
                name: item.trim()
                // code: index.toString()  // Assign a unique numeric code based on index
            }));

            console.log("[parseOptions] result = ", result);

            return result;
        },
        async createEntry() {
            this.submitted = true;

            try {
                console.log("[createEntry] this.digitalForm.formComponent = ", this.digitalForm.formComponent);

                this.digitalForm.responses = this.digitalForm.formComponent
                    .filter(component => component.type === 'S' || component.type === 'B' || component.type === 'N'
                        || component.type === 'D' || component.type === 'G' || component.type === 'M')
                    .filter(component => component.status === 'A')
                    .map(component => {
                        let responseValue = component.response;

                        // If the component type is 'G', use the signature value
                        if (component.type === 'G') {
                            responseValue = this.$refs.signature.save();
                        }

                        if (component.type === 'D') {
                            responseValue = moment(component.response).format('YYYY-MM-DD');
                        }

                        if (component.type === 'M' && typeof responseValue === 'string') {
                            responseValue = responseValue.trim();
                        }

                        return {
                            formId: this.digitalForm.id,
                            formName: this.digitalForm.name,
                            formComponentId: component.id,
                            formComponentName: component.name,
                            response: responseValue,
                        };
                    });

                // Log the responses for debugging or handle form submission here
                console.log("this.digitalForm = ", this.digitalForm);
                console.log("this.digitalForm.responses = ", this.digitalForm.responses);

                const response = await DigitalForm.createDigitalFormResponse(this.digitalForm.id, this.digitalForm.responses);
                console.log('[Forms][createDigitalForm] Response = ', response);

                this.$toast.add({
                    severity: 'success',
                    summary: 'Successful',
                    detail: 'Successfully completed digital form',
                    life: 3000
                });

                this.resetForm();

            } catch (error) {
                console.error('[PhoneCalls][deletePhoneCall] Error:', error);

                this.$toast.add({
                    severity: 'error',
                    summary: 'Error',
                    detail: 'Failed to complete digital form. Please try again.',
                    life: 3000
                });
            }

            this.activeTab = 1;
            this.submitted = false;
        },
    }
};
</script>

<style scoped>
a {
    text-decoration: none;
}

img {
    max-width: 100%;
    height: auto;
}

.form-logo {
    width: clamp(120px, 40vw, 240px);
    height: auto;
    display: block;
    margin: 0 auto;
}
</style>
